export default __webpack_public_path__ + "static/media/article17.3604dfb2.png";